/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSquareFootIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-square-foot"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.4 21.95Q3.42 21.95 2.74 21.26Q2.05 20.57 2.05 19.6L2.05 3.95Q2.05 3.23 2.73 2.94Q3.4 2.65 3.9 3.15L6.8 6.05L5.2 7.65L5.9 8.35L7.5 6.75L10.4 9.65L8.8 11.25L9.5 11.95L11.1 10.35L13.95 13.2L12.35 14.8L13.05 15.5L14.65 13.9L17.5 16.75L15.9 18.35L16.65 19.1L18.25 17.5L20.85 20.1Q21.35 20.6 21.06 21.27Q20.77 21.95 20.05 21.95ZM5.7 18.3L14.15 18.3L5.7 9.85L5.7 18.3Q5.7 18.3 5.7 18.3Q5.7 18.3 5.7 18.3Z" fill={color} />
    </svg>
  );
}
